// extracted by mini-css-extract-plugin
export default {"container":"_inputswitch_container__BZdgc","input":"_inputswitch_input__5vSLd"};